import React, {useEffect, useState} from 'react';
import Chart from "react-apexcharts";

import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    FormControl,
    Grid,
    InputLabel,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHead,
    TableRow,
    Theme,
    Typography
} from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';
import {AppBar, ButtonResponsive, ListViewMode, LoadingProgress, MostrarError} from "../../components";
import {FilterList} from "@mui/icons-material";
import Strings from '../../assets/strings'
import {getEgresosGrafico, getResumenGrafico} from "../../services";
import {SelectRuta} from "../../components/selects";
import {formatPeso, moment, translateText} from "../../helpers";
import {SelectSmart} from "../../components/CustomTextField";

const useStyles = makeStyles((theme:Theme) => ({
    root:{
    },
    anulado:{
        background: "#fff1f1",
        "& td, th":{
            color:theme.palette.error.light,
        }
    },
    topTotal:{
        background: theme.palette.grey[200],
        width: 250,
        padding: "3px 8px",
        marginBottom: 7,
        float: "right"
    },
    titleBar:{
        background: theme.palette.grey[200],
        borderBottom: "2px solid "+theme.palette.primary.main,
        marginBottom:theme.spacing(1),
        padding:theme.spacing(1),
    }
}));


const CURRENT_YEAR = new Date().getFullYear();
function years() {
    let years = [];
    let year = CURRENT_YEAR;
    for(let i=0;i<=7;i++){
        years.push(year--);
        year = year--
    }
    return years;
}
const initialState:{anio:number,rutaId?:number }={
    anio: CURRENT_YEAR,
    rutaId:undefined
}
type TDataSerie = {
    name:string,
    data:number[]
}

export default function Ingresos() {
    const classes = useStyles();
    const [dataPointIndex, setDataPointIndex] = useState(null);
    const [dataPointIndexEgreso, setDataPointIndexEgreso] = useState(null);

    const [series, setSeries] = useState<{name:string, data:number[]}[]>([]);
    const [seriesEgreso, setSeriesEgreso] = useState<{name:string, data:number[]}[]>([]);


    const [verTableIngresos, setVerTableIngresos] = useState(false);
    const [verTableEgresos, setVerTableEgresos] = useState(false);


    const buildOptionsChart = (isEgreso: boolean = false)=>{
        const optionsChart:ApexCharts.ApexOptions = {
            chart: {
                height: 350,
                stacked: Boolean((isEgreso ? dataPointIndexEgreso : dataPointIndex) === null),
                toolbar: {
                    show: true,
                    offsetX: 0,
                    offsetY: 0,
                    tools: {
                        download: false,
                        selection: true,
                        zoom: false,
                        zoomin: false,
                        zoomout: false,
                        pan: false,
                        reset: false ,
                    },
                },
                events: {
                    dataPointSelection: function (e, chart, opts) {


                        if(isEgreso){
                            setDataPointIndexEgreso(dataPointIndexEgreso === null? opts.dataPointIndex: null);
                        }else{
                            setDataPointIndex(dataPointIndex === null? opts.dataPointIndex:null);
                        }
                    }
                }
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    //  columnWidth: '65%',
                    // endingShape: 'flat'
                },
            },
            // grid: {
            //     borderColor: '#ccc',
            //     strokeDashArray: 7,
            //     xaxis: {
            //         lines: {
            //             show: true
            //         }
            //     }
            // },
            dataLabels: {
                enabled: Boolean((isEgreso ? dataPointIndexEgreso : dataPointIndex) !== null),
                formatter: function (val) {
                    return formatPeso(val);
                },
                // offsetY: -20,
                style: {
                    //  fontSize: '12px',
                    colors: ["#304758"]
                }
            },

            stroke: {
                show: true,
                width: 1,
                colors: ['transparent']
            },
            xaxis: {
                categories: (isEgreso ? dataPointIndexEgreso : dataPointIndex) !== null ? [(isEgreso ? dataPointIndexEgreso : dataPointIndex)]:[...Array(12).keys()],
                labels: {
                    formatter: (number) => moment().month(number).format((isEgreso ? dataPointIndexEgreso : dataPointIndex) !== null ?"MMMM" :"MMM"),
                }
            },
            yaxis: {
                labels: {
                    formatter: (value) => value.toFixed(),
                }
            },
            fill: {
                opacity: 1
            },
            tooltip: {
                enabled: Boolean((isEgreso ? dataPointIndexEgreso : dataPointIndex) === null),
                shared: true,
                intersect:false,
                followCursor:true,
                y: {
                    formatter: (value) => formatPeso(value),
                }
            }

        };

        return optionsChart
    }


    const [openFilter, setOpenFilter] = useState(false)
    const [filter, setFilter] = useState(initialState);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();
    const [clearData, setClearData] = useState<{name:string, data:number[]}[]>([]);
    const [clearDataEgreso, setClearDataEgreso] = useState<{name:string, data:number[]}[]>([]);


    useEffect(() => {
        setLoading(true)
        getResumenGrafico(filter.anio,filter.rutaId).then(({data}) => {
            let list:TDataSerie[] = [];

            (data as TDataSerie[])?.forEach(e=>{
                if(Math.max(...e.data) !== 0){
                    list.push(e)
                }
            })
            setSeries(list)
        }).finally(()=>setLoading(false))
    }, [filter,setSeries,setLoading]);

    useEffect(()=>{
        let datos = series || [];
        let converted:{name:string, data:number[]}[] = [];

        if(datos.length) {
            converted = datos.map(e => (
                {
                    name: translateText(e.name),
                    data: dataPointIndex !== null ? [e.data[dataPointIndex]] : e.data
                }
            ));
        }
        setClearData(converted);
    },[series,dataPointIndex,setClearData]);

    //Egresos

    useEffect(() => {
        setLoading(true)
        getEgresosGrafico(filter.anio,filter.rutaId).then(({data}) => {
            let list:TDataSerie[] = [];

            (data as TDataSerie[])?.forEach(e=>{
                if(Math.max(...e.data) !== 0){
                    list.push(e)
                }
            })
            setSeriesEgreso(list)
        }).finally(()=>setLoading(false))
    }, [filter,setSeriesEgreso,setLoading]);

    useEffect(()=>{
        let datos = seriesEgreso || [];
        let converted:{name:string, data:number[]}[] = [];

        if(datos.length) {
            converted = datos.map(e => (
                {
                    name: translateText(e.name),
                    data: dataPointIndexEgreso !== null ? [e.data[dataPointIndexEgreso]] : e.data
                }
            ));
        }

        setClearDataEgreso(converted);
    },[seriesEgreso,dataPointIndexEgreso,setClearDataEgreso]);







    const handleFilter = (e:React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = e.target;
        setFilter({...filter,[name]:value});
    };

    const searchFilter = () => {
        setOpenFilter(false);
    };

    const mesTotal = () => {
        let totalsIngresos:number[] = []
        let totalsEgresos:number[] = []
        let resultado:number[] = []

        series.forEach(e=>{
            e.data.forEach((monto,index)=>{
                totalsIngresos[index] = (totalsIngresos[index] ?? 0 ) + monto
            })
        })
        seriesEgreso.forEach(e=>{
            e.data.forEach((monto,index)=>{
                totalsEgresos[index] = (totalsEgresos[index] ?? 0 ) + monto
            })
        })

        totalsIngresos.forEach((monto, i)=>{
            resultado[i] = monto - totalsEgresos[i]
        })

        let empty = [0,0,0,0,0,0,0,0,0,0,0,0];
        return {
            totalsIngresos: !!totalsIngresos?.length ? totalsIngresos : empty,
            totalsEgresos: !!totalsEgresos?.length ? totalsEgresos : empty,
            resultado: !!resultado?.length ? resultado : empty
        }
    }
    let totales = mesTotal();

    return (
      <>
          <Dialog open={openFilter} onClose={()=>setOpenFilter(false)} fullWidth maxWidth={"xs"}>
              <DialogContent>
                  <Grid container spacing={3}>
                      <Grid item xs={12} sm={4}>
                          <FormControl fullWidth>
                              <InputLabel>{Strings.anio}</InputLabel>
                              <SelectSmart
                                  name={"anio"}
                                  value={filter.anio}
                                  onChange={handleFilter}
                                  opciones={years().map((year) =>({key:year,value:year}))}
                              />
                          </FormControl>

                      </Grid>
                      <Grid item xs={12} sm={8}>
                          <SelectRuta value={filter.rutaId} name={"rutaId"} onChange={handleFilter} />
                      </Grid>
                  </Grid>
                  <br/>
              </DialogContent>
              <DialogActions>
                  <Button onClick={()=> {
                      setFilter(initialState)
                      setOpenFilter(false)
                  }} color="warning" variant={"text"}>{Strings.cancelar}</Button>
                  <Button color="primary" onClick={searchFilter} variant={"outlined"}>{Strings.filtrar}</Button>
              </DialogActions>
          </Dialog>

          <AppBar title={Strings.ingresosVsGastos}/>
          <section className={"contentInner "+classes.root}>
              {loading && <LoadingProgress vh/>}
              {error && <MostrarError errors={error}/>}
              <ListViewMode noView >
                  <ButtonResponsive icon={<FilterList/>} text={Strings.filtrar} onClick={() => setOpenFilter(!openFilter)}/>
              </ListViewMode>
              <br/>
              <Grid container spacing={3}>
                  <Grid item xs={12}>
                      <TableContainer>
                          <Table size={"small"}>
                              <TableHead>
                                  <TableRow>
                                      <TableCell width={100}/>
                                      {[...Array(12).keys()].map(number=>
                                          <TableCell align={"right"} key={number} sx={{textTransform:"capitalize"}}>{moment().month(+number).format("MMMM")}</TableCell>
                                      )}
                                      <TableCell align={"right"}>{Strings.total}</TableCell>
                                  </TableRow>
                              </TableHead>
                              <TableBody>
                                  <TableRow>
                                      <TableCell sx={{fontWeight:500}}>{Strings.ingresos}</TableCell>
                                      {totales.totalsIngresos.map((monto,i)=>
                                          <TableCell key={i} align={"right"}>{formatPeso(monto)}</TableCell>
                                      )}
                                      <TableCell align={"right"}>{formatPeso(totales.totalsIngresos?.reduce((a,b)=>a + b, 0))}</TableCell>
                                  </TableRow>
                                  <TableRow>
                                      <TableCell sx={{fontWeight:500}}>{Strings.egresos}</TableCell>
                                      {totales.totalsEgresos.map((monto,i)=>
                                          <TableCell key={i} align={"right"}>{formatPeso(monto)}</TableCell>
                                      )}
                                      <TableCell align={"right"}>{formatPeso(totales.totalsEgresos?.reduce((a,b)=>a + b, 0))}</TableCell>
                                  </TableRow>
                                  <TableRow>
                                      <TableCell sx={{fontWeight:500}}>Resultado por Mes</TableCell>
                                      {totales.resultado.map((monto,i)=>
                                          <TableCell key={i} align={"right"} className={monto < 0? "text-red":""}>{monto < 0? <>({formatPeso(monto)})</> : formatPeso(monto)}</TableCell>
                                      )}

                                          {(totales.resultado?.reduce((a,b)=>a + b, 0) < 0) ?
                                              (
                                                  <TableCell align={"right"} className={"text-red"}>
                                                      {formatPeso(totales.resultado?.reduce((a,b)=>a + b, 0))}
                                                  </TableCell>
                                              ):(
                                                    <TableCell align={"right"} >
                                                        {formatPeso(totales.resultado?.reduce((a,b)=>a + b, 0))}
                                                    </TableCell>
                                              )
                                          }

                                  </TableRow>
                              </TableBody>
                              {/*<TableFooter>*/}
                              {/*    <TableRow>*/}
                              {/*        <TableCell sx={{fontWeight:500}}>Resultado por Mes</TableCell>*/}
                              {/*        {totales.resultado.map((monto,i)=>*/}
                              {/*            <TableCell key={i} align={"right"}>{formatPeso(monto + (totales.resultado[i -1] ?? 0 ))}</TableCell>*/}
                              {/*        )}*/}
                              {/*    </TableRow>*/}
                              {/*</TableFooter>*/}
                          </Table>
                      </TableContainer>
                  </Grid>

                  <Grid item xs={12} lg={6}>
                      <Paper variant={"outlined"}>
                          <Grid container spacing={3}>
                              <Grid item xs={12}>
                                  <Box textAlign={"center"} width={"100%"} mt={2}>
                                      <Typography color={"secondary"} >
                                          {"Grafico de ingresos".toUpperCase()} {dataPointIndex !== null && "( "+moment().month(dataPointIndex).format("MMMM").toUpperCase()+" )"}
                                      </Typography>
                                      {dataPointIndex !== null &&
                                          <Typography>
                                              {Strings.total} = {formatPeso(clearData.reduce((a, b) => +a + +b.data[0], 0))}
                                          </Typography>
                                      }
                                  </Box>
                                  <Chart options={buildOptionsChart()} series={clearData} type="bar" height={350} />
                                  <Box display={"flex"} justifyContent={"center"} color={"#8f8e8e"}>
                                      <Button color={"inherit"} size={"small"} sx={{margin:"0 auto", textTransform: "none"}}  onClick={()=>setVerTableIngresos(!verTableIngresos)}>{!verTableIngresos? "Ver":"Ocultar"} Tabla</Button>
                                  </Box>
                              </Grid>
                              <Grid item xs={12}>

                                  {!!verTableIngresos &&
                                      <TableContainer>
                                          <Table size={"small"}>
                                              <TableHead>
                                                  <TableRow>
                                                      <TableCell/>
                                                      {[...Array(12).keys()].map(number=>
                                                          <TableCell align={"right"} key={number} sx={{textTransform:"capitalize"}}>{moment().month(+number).format("MMMM")}</TableCell>
                                                      )}

                                                  </TableRow>
                                              </TableHead>
                                              <TableBody>
                                                  {series.map(serie=>
                                                      <TableRow key={serie.name}>
                                                          <TableCell align={"right"}>{serie.name?.toUpperCase()}</TableCell>
                                                          {serie.data?.map((monto, i)=>
                                                              <TableCell align={"right"} key={i}>{formatPeso(monto)}</TableCell>
                                                          )}
                                                      </TableRow>
                                                  )}
                                              </TableBody>
                                              <TableFooter>
                                                  <TableRow>
                                                      <TableCell align={"right"}>{Strings.total}:</TableCell>

                                                      {totales.totalsIngresos?.map((monto,i)=>
                                                          <TableCell key={i} align={"right"}>{formatPeso(monto)}</TableCell>
                                                      )}
                                                  </TableRow>
                                              </TableFooter>
                                          </Table>
                                      </TableContainer>
                                  }
                              </Grid>
                          </Grid>
                      </Paper>
                  </Grid>
                  <Grid item xs={12} lg={6}>
                      <Paper variant={"outlined"}>
                          <Grid container spacing={3}>
                              <Grid item xs={12}>
                                  <Box textAlign={"center"} width={"100%"} mt={2}>
                                      <Typography color={"secondary"} >
                                          {"Grafico de egresos".toUpperCase()} {dataPointIndexEgreso !== null && "( "+moment().month(dataPointIndexEgreso).format("MMMM").toUpperCase()+" )"}
                                      </Typography>
                                      {dataPointIndexEgreso !== null &&
                                          <Typography>
                                              {Strings.total} = {formatPeso(clearDataEgreso.reduce((a, b) => +a + +b.data[0], 0))}
                                          </Typography>
                                      }
                                  </Box>
                                  <Chart options={buildOptionsChart(true)} series={clearDataEgreso} type="bar" height={350} />
                                  <Box display={"flex"} justifyContent={"center"} color={"#8f8e8e"}>
                                      <Button color={"inherit"} size={"small"} sx={{margin:"0 auto", textTransform: "none"}}  onClick={()=>setVerTableEgresos(!verTableEgresos)}>{!verTableEgresos? "Ver":"Ocultar"} Tabla</Button>
                                  </Box>
                              </Grid>
                              <Grid item xs={12}>
                                {!!verTableEgresos &&
                                      <TableContainer>
                                          <Table size={"small"}>
                                              <TableHead>
                                                  <TableRow>
                                                      <TableCell/>
                                                      {[...Array(12).keys()].map(number=>
                                                          <TableCell align={"right"} key={number} sx={{textTransform:"capitalize"}}>{moment().month(+number).format("MMMM")}</TableCell>
                                                      )}

                                                  </TableRow>
                                              </TableHead>
                                              <TableBody>
                                                  {seriesEgreso.map(serie=>
                                                      <TableRow key={serie.name}>
                                                          <TableCell align={"right"}>{serie.name?.toUpperCase()}</TableCell>
                                                          {serie.data?.map((monto, i)=>
                                                              <TableCell align={"right"} key={i}>{formatPeso(monto)}</TableCell>
                                                          )}
                                                      </TableRow>
                                                  )}
                                              </TableBody>
                                              <TableFooter>
                                                  <TableRow>
                                                      <TableCell align={"right"}>{Strings.total}:</TableCell>
                                                      {totales.totalsEgresos?.map((monto,i)=>
                                                          <TableCell key={i} align={"right"}>{formatPeso(monto)}</TableCell>
                                                      )}
                                                  </TableRow>
                                              </TableFooter>
                                          </Table>
                                      </TableContainer>
                                }
                              </Grid>
                          </Grid>
                      </Paper>
                  </Grid>
              </Grid>


          </section>
      </>
    );
}
